<template>
    <div>
        <div class="item">
            <label class="check_wrap">
                <input type="checkbox" v-model="column.isSelected" @click="action_SelectItem">
                <span class="checkmark"></span>
                <span class="txt ellipsis">{{ columnString }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: { 
        column: Object,
        index: Number,
    },
    watch: {

    },
    mounted() {

    },
    computed: {
        columnString: function() {
            return this.column.title ?? '-'
        },
    },
    methods: {
        action_SelectItem() {
            this.$emit('action_SelectItem', this.column)
        }
    }
}
</script>